import { useSnapshot } from 'valtio';
import { mapState } from '~/components2/Map/Map';

/** Top-left overlay; rotates with map bearing so N aligns with true north. */
export function PermittingNorthArrow() {
  const { viewState } = useSnapshot(mapState) as typeof mapState;
  const bearing = viewState.bearing;

  return (
    <div
      className="pointer-events-none absolute left-2 top-2 z-[46] rounded border border-grey-30/80 bg-white/95 px-1 py-0.5 shadow-sm print:hidden"
      id="permitting-north-arrow"
      aria-hidden
    >
      <div
        className="flex items-center justify-center"
        style={{
          transform: `rotate(${-bearing}deg)`,
          transformOrigin: '50%',
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={20}
          height={24}
          viewBox="0 0 28 34"
          aria-hidden
          focusable="false"
        >
          <title>North</title>
          <path d="M14 3 L24 22 L14 17 L4 22 Z" fill="#243442" stroke="#fff" strokeWidth={1} strokeLinejoin="round" />
          <text
            x="14"
            y="31"
            textAnchor="middle"
            fontSize={11}
            fontWeight={600}
            fontFamily="Noto Sans, system-ui, sans-serif"
            fill="#243442"
          >
            N
          </text>
        </svg>
      </div>
    </div>
  );
}
